import React, { forwardRef } from 'react';
import './input-list-item.scss';
export var InputListItem = forwardRef(function (_a, ref) {
    var type = _a.type, id = _a.id, name = _a.name, value = _a.value, onChange = _a.onChange, disabled = _a.disabled, displayText = _a.displayText;
    return (React.createElement("label", { htmlFor: id.toString(), className: "c-input-list-item" },
        React.createElement("input", { type: type, id: id.toString(), name: name, defaultValue: value, ref: ref, onChange: onChange, disabled: disabled }),
        React.createElement("span", { className: "c-radio-input__inner" },
            React.createElement("span", null, displayText ? displayText : value))));
});
InputListItem.displayName = 'InputListItem';
